const SHORT_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
] as const;

function dayWithOrdinal(day: number): string {
  const mod100 = day % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${day}th`;
  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

/** e.g. "Mar 1st 2026" in local timezone; empty input → empty string */
export function formatMediumOrdinalDate(isoLike: string | undefined | null): string {
  const raw = (isoLike ?? '').trim();
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '';
  const month = SHORT_MONTHS[d.getMonth()];
  const dayOrd = dayWithOrdinal(d.getDate());
  const year = d.getFullYear();
  return `${month} ${dayOrd} ${year}`;
}
